import SvgIcon from 'components/SvgIcon/SvgIcon'
import './WpHeader.scss'
import WpSearchField from 'layouts/shop/WpHeader/WpSearchField'
import WpMenuItems from 'layouts/shop/WpHeader/WpMenuItems'
import useHeaderScroll from 'layouts/shop/WpHeader/useHeaderScroll'
import useIsLogged from "utils/useIsLogged"
import { useSelector } from 'store'
import MyLink from 'components/MyLink'
import { getInitialsFromName } from 'utils/stringUtils'
import { useState } from 'react'

const WpHeader = ({ onAccountIconClicked, shouldAlwaysShowAccount }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const isScrolled = useHeaderScroll()
  const isLogged = useIsLogged()
  const nrProductsInCart = useSelector?.((state) => state.shop?.cartData?.productCount || 0)
  const name = useSelector?.((state) => state.user?.name || '')

  const accountLink = isLogged ? (
    <MyLink to='/shop/cart' className='blueMenuItem'>
      <div className="cart-icon-container">
        <SvgIcon name='cartempty' className='wpcart'/>
        <span className="cart-badge">{nrProductsInCart}</span>
      </div>
      <span className="menu-label">Coșul meu</span>
    </MyLink>
  ) : (
    <MyLink to='/shop/signin' className='blueMenuItem'>
      <SvgIcon name='wpuser' className='wpuser'/>
      <span className="menu-label">Intră în cont</span>
    </MyLink>
  )

  return (
    <header className={`wpHeader ${isScrolled ? 'scrolled' : ''}`}>
      <ul className={`blueRow ${isSearchOpen ? 'search-open' : ''}`}>
        <WpSearchField
          isScrolled={isScrolled}
          isSearchOpen={isSearchOpen}
          setIsSearchOpen={setIsSearchOpen}
        />
        <li className='blueMenuItem'>
          <MyLink to='/shop/productlist' className='blueMenuItem'>
            <SvgIcon name='online_store' className='wpcart'/>

            <span className="menu-label">Magazinul online</span>
          </MyLink>
        </li>
        <li className='blueMenuItemWrapper'>{accountLink}</li>
        <li className='blueMenuItem'>
          <MyLink to={`${process.env?.REACT_APP_WORDPRESS_URL}/contact/`} className='blueMenuItem'>
            <SvgIcon name='wpenvelope' className='wpenvelope'/>
            <span className="menu-label">Contact</span>
          </MyLink>
        </li>
      </ul>
      <WpMenuItems isScrolled={isScrolled} />
      <div className="whiteRow">
        <div className="whiteRowText">
          Dezvoltatorul primului ecosistem dedicat exclusiv profesioniștilor în instalații, HVAC și echipamente de încălzire/răcire, din România.
        </div>
        {isLogged && (
        <div
          data-test-id='tGJV'
          className={`headerAccountButton logged-in-button ${shouldAlwaysShowAccount ? 'always-show' : ''}`}
          onClick={() => onAccountIconClicked?.()}
            
        >
          <div data-test-id='UO1S' className="inner-circle">{getInitialsFromName?.(name)}</div>
        </div>
      )}
      </div>
    </header>
  )

}

export default WpHeader
